import React from "react";
import { motion } from "framer-motion";

export const IMAGES = {
  hero: `${process.env.PUBLIC_URL || ""}/hero-diu-fort.webp`,
  about: `${process.env.PUBLIC_URL || ""}/about-diu-street.webp?v=2`,
  build: `${process.env.PUBLIC_URL || ""}/whatwebuild-harbor.webp`,
  why: `${process.env.PUBLIC_URL || ""}/whydnhdd-coastline.webp`,
  way: `${process.env.PUBLIC_URL || ""}/fortimway-solarfarm.webp`,
  vision: `${process.env.PUBLIC_URL || ""}/vision-riverside.webp`,
};

export const LINKEDIN_URL = "https://www.linkedin.com/company/fortim-ventures/";

export const PRIMARY_LOGO = `${process.env.PUBLIC_URL || ""}/logo-primary.webp`;
export const ICON_LOGO = `${process.env.PUBLIC_URL || ""}/logo-icon.png`;

export const LEADERS = [
  {
    initials: "YF",
    name: "Yatin Fugro",
    role: "Chairman",
    bio: "Yatin provides stewardship and long-term perspective, drawing on a family history of enterprise in the region that stretches back generations. He guides Fortim's commitment to building businesses that create value for partners and communities alike.",
  },
  {
    initials: "RF",
    name: "Raunak Fugro",
    role: "Founder & Managing Director",
    bio: "Raunak leads Fortim's day-to-day direction, shaping the ventures, partnerships and strategies the company builds across DNHDD. His focus is on disciplined execution and relationships that endure well beyond any single transaction.",
  },
];

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "leadership", label: "Leadership", route: "/leadership" },
  { id: "build", label: "What We Build" },
  { id: "focus", label: "Where We Focus" },
  { id: "why", label: "Why DNHDD" },
  { id: "way", label: "The Fortim Way" },
  { id: "vision", label: "Vision" },
  { id: "contact", label: "Contact" },
];

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

// Consistent scroll reveal: fade + 20px upward slide, ease-out.
export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.65, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Eyebrow label with small orange marker.
export const Eyebrow = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="h-px w-8" style={{ background: "#F5821F" }} />
    <span
      className="eyebrow text-xs font-medium"
      style={{ color: dark ? "#8C8C8C" : "#8C8C8C" }}
    >
      {children}
    </span>
  </div>
);
